import { render, staticRenderFns } from "./CoffeeBeans.vue?vue&type=template&id=1d3f0814&scoped=true&"
import script from "./CoffeeBeans.vue?vue&type=script&lang=js&"
export * from "./CoffeeBeans.vue?vue&type=script&lang=js&"
import style0 from "./CoffeeBeans.vue?vue&type=style&index=0&id=1d3f0814&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f0814",
  null
  
)

export default component.exports